import React from "react";
import { Beer, AppWindow } from "lucide-react";

import olympicImg from "../assets/olympic.jpg";
import paragonImg from "../assets/paragon.jpg";
import kilncareImg from "../assets/kilncare.jpg";
import naberthermImg from "../assets/nabertherm.png";
import evenheatImg from "../assets/evenheat.png";
import skuttImg from "../assets/skutt.png";
import northernImg from "../assets/northern.png";
import rohdeImg from "../assets/rohde_logo.png";
import jenKenImg from "../assets/jen-ken_logo.jpg";
import cressImg from "../assets/cress-logo.png";
import cromartieImg from "../assets/cromartie-logo.png";
import coneArtImg from "../assets/coneartlogo.png";
import woodrowImg from "../assets/woodrow.png";
import bartlettImg from "../assets/bartlett.png";
import spectrumImg from "../assets/spectrum.jpg";
import spectrumCenteredImg from "../assets/spectrum_centered.png";
import bullseyeImg from "../assets/bullseye.jpg";
import iconImg from "../assets/icon.png";

export const kilnLogo = (manufacturer?: string): string => {
  switch (manufacturer) {
    case "Olympic":
      return olympicImg;
    case "Paragon":
      return paragonImg;
    case "Kilncare":
      return kilncareImg;
    case "Nabertherm":
      return naberthermImg;
    case "Evenheat":
      return evenheatImg;
    case "Skutt":
      return skuttImg;
    case "Northern":
      return northernImg;
    case "Rohde":
      return rohdeImg;
    case "Jen-Ken":
      return jenKenImg;
    case "Cress":
      return cressImg;
    case "Cromartie":
      return cromartieImg;
    case "Cone Art":
      return coneArtImg;
    case "Woodrow":
      return woodrowImg;
    // deepcode ignore DuplicateCaseBody: Temporary fall-back
    default:
      return naberthermImg;
  }
};

export const controllerLogo = (controller?: string): string | undefined => {
  switch (controller) {
    case "bartlett_genesis":
      return bartlettImg;
    default:
      return undefined;
  }
};

export const glassImage = (glass?: string): string => {
  switch (glass) {
    case "Spectrum":
      return spectrumCenteredImg;
    case "Bullseye":
      return bullseyeImg;
    default:
      return iconImg;
  }
};

// Full-logo reference (off-centre for Spectrum) — only use when you need the
// manufacturer's raw logo rather than a circular mark.
export const glassLogoFull = (glass?: string): string => {
  switch (glass) {
    case "Spectrum":
      return spectrumImg;
    case "Bullseye":
      return bullseyeImg;
    default:
      return iconImg;
  }
};

export const glassIcon = (glass?: string): React.ReactNode => {
  switch (glass) {
    case "Spectrum":
      return <img src={spectrumCenteredImg} alt="Spectrum" className="inline-block h-6 w-6 rounded-full object-cover" />;
    case "Bottle":
      return <Beer className="inline-block h-5 w-5" />;
    case "Float":
      return <AppWindow className="inline-block h-5 w-5" />;

    case "Bullseye":
    default:
      return <img src={bullseyeImg} alt="Bullseye" className="inline-block h-6 w-6 rounded-full object-cover" />;
  }
};
